<template>
<div class="chapter">
<div class="inner_page">
<div class="block">
<p class="nonindent" id="fm2">…but oh my desert<br/>yours is the only death I cannot bear.</p>
<p class="right">—Richard Shelton</p>
<p class="center">Resist much. Obey little.</p>
<p class="right">—Walt Whitman</p>
<p class="center">Now. Or never.</p>
<p class="right">—Thoreau</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795317361_epub_fm2_r1.vue?1dcb08d1